import styled from 'styled-components';
import { key } from 'styled-theme';

export default styled.div<{ align?: string; bold?: boolean; color?: string }>`
  color: ${key('colors.SIDB.light.400')};

  .amount {
    font-size: 2em;
    display: block;
    font-weight: ${props => (props.bold ? 'bold' : 'normal')};
    color: ${props => props.color};
  }

  text-align: ${props => props.align || 'left'};
`;
